export const ErrorMapping = [
  {
    code: -1,
    message: 'خطایی رخ داده لطفا بعدا تلاش نمایید',
  },
  {
    code: 10010,
    message: 'کاربر قبلا با این شماره ثبت نام کرده است',
  },
  {
    code: 10011,
    message: 'خطا در ارسال کد تایید برای کاربر',
  },
  {
    code: 10012,
    message: 'ارسال کد تایید برای بازیابی رمز عبور با خطا مواجه شد',
  },
  {
    code: 10013,
    message: 'پر شدن ظرفیت ارسال کد تایید. لطفا بعد از ۲۴ ساعت دیگه تلاش نمایید',
  },
  {
    code: 10014,
    message: 'قبلا برای این کاربر کد تایید ارسال شده است',
  },
  {
    code: 10015,
    message: 'خطا در ارسال کد تایید مجدد',
  },
  {
    code: 10017,
    message: 'ارسال کد تایید برای کاربر رزرو نشده است',
  },
  {
    code: 10018,
    message: 'زمان ارسال کد تایید به پایان رسیده است',
  },
  {
    code: 10019,
    message: 'کد تایید وارد شده صحیح نمی‌باشد',
  },
  {
    code: 10020,
    message: 'عملیات ثبت نام با خطا مواجه شد این شماره قبلا ثبت نام کرده است',
  },
  {
    code: 10021,
    message: 'شماره موبایل و رمز عبور اجباری می‌باشند',
  },
  {
    code: 10022,
    message: 'نام کاربری یا رمز عبور صحیح نمی‌باشد',
  },
  {
    code: 10023,
    message: 'کاربر فعال نیست',
  },
  {
    code: 10024,
    message: 'این شماره تلفن هنوز ثبت نشده است',
  },
  {
    code: 10025,
    message: 'خطا در ویرایش اطلاعات حساب کاربری',
  },
  {
    code: 10026,
    message: 'خطا در ویرایش اطلاعات حساب کاربری',
  },
  {
    code: 10027,
    message: 'مجوز شناسه یکتا ارسال نشده',
  },
  {
    code: 10030,
    message: 'شماره موبایل وجود ندارد',
  },
  {
    code: 10031,
    message: 'زمان انقصای شناسه کاربری شما به پایان رسیده لطفا مجددا وارد شوید',
  },
  {
    code: 10032,
    message: 'زمان انقصای شناسه کاربری شما به پایان رسیده',
  },
  {
    code: 10033,
    message: 'محدودیت معتبری ارائه نشده است',
  },
  {
    code: 10034,
    message: 'محصولی یافت نشد',
  },
  {
    code: 10035,
    message: 'کاربری یافت نشد',
  },
  {
    code: 10036,
    message: 'تصویر کپچای الزامی می‌باشد',
  },
  {
    code: 10037,
    message: 'تصویر کپچای وارد شده صحیح نمی‌باشد',
  },
  {
    code: 10038,
    message: ' زمان انقصای کپچای وارد شده به پایان رسیده است',
  },
  {
    code: 10039,
    message: 'تصویر کپچای وارد شده صحیح نمی‌باشد',
  },
  {
    code: 10040,
    message: 'موجودی شما کافی نیست',
  },
  {
    code: 10041,
    message: 'محصولی یافت نشد',
  },
  {
    code: 10042,
    message: 'درخواست شغلی یافت نشد یا قبلاً پردازش شده است',
  },
  {
    code: 10043,
    message: 'درخواست شغلی پیدا نشد',
  },
  {
    code: 10044,
    message: 'پست کاری یا رزومه یافت نشد',
  },
  {
    code: 10045,
    message:
      'کاربر نمی تواند رزومه خود را برای این پیشنهاد ارسال کند زیرا مشخصات نمایش کاربر نادرست است و باید آن را در نمایه کاربر به روز کند',
  },
  {
    code: 10046,
    message: 'کاربر نمی تواند رزومه ارسال کند کاربر رزومه ندارد',
  },
  {
    code: 10047,
    message: 'نوع فایل نامعتبر است، فقط PNG و JPG مجاز هستند',
  },
  {
    code: 10048,
    message: 'اندازه فایل از حد مجاز 5 مگابایت بیشتر است',
  },
  {
    code: 10049,
    message: 'امکان ارسال رزومه به این پیشنهاد شغلی (برنامه شغلی تکراری) وجود ندارد',
  },
  {
    code: 10050,
    message: 'ادمین سازمانی قبلاً در super admin اضافه شده است',
  },
  {
    code: 10051,
    message: 'ادمین سازمانی که می‌خواهید حذف کنید با این شناسه یافت نشد',
  },
  {
    code: 10052,
    message: 'شماره موبایل باید 13 رقمی باشد',
  },
  {
    code: 10053,
    message: 'قوانین و مقررات پیدا نشد',
  },
  {
    code: 10054,
    message: ' پایگاه دانش پیدا نشد',
  },
  {
    code: 10055,
    message: ' سازمان پیدا نشد',
  },
  {
    code: 10055,
    message: ' سازمان پیدا نشد',
  },
  {
    code: 10056,
    message: 'نمی توان این ادمین سازمان را با این شماره اضافه کرد زیرا قبلاً وجود داشته است',
  },
  {
    code: 10057,
    message: 'نمی توان این کاربر را با این شماره اضافه کرد زیرا قبلاً وجود داشته است',
  },
  {
    code: 20500,
    message: 'در حین انتقال خطا داریم: {e}',
  },
  {
    code: 20400,
    message: 'محصول کافی در موجودی سازمان وجود ندارد',
  },
];
